<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-list two-line subheader>
          <v-subheader inset>Settings</v-subheader>
          <v-list-tile avatar v-for="item in items" v-bind:key="item.title" @click="item.action">
            <v-list-tile-avatar>
              <v-icon v-bind:class="[item.iconClass]">{{ item.icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
    <v-snackbar
      v-model="snackbar"
    >
      {{snackbarText}}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
  export default {
    data () {
      return {
        items: [
          { icon: 'history', iconClass: 'grey lighten-1 white--text', title: 'Reset', subtitle: 'Refresh the app to get the latest version', action: this.resetApp }
        ],
        snackbar: false,
        snackbarText: '',
        cameraQuality: 0
      }
    },
    watch: {
      cameraQuality: function (val) {
        localStorage.setItem('cameraQuality', val)
      }
    },
    created () {
      this.cameraQuality = localStorage.getItem('cameraQuality') !== null && localStorage.getItem('cameraQuality') !== undefined ? localStorage.cameraQuality : 50
    },
    methods: {
      resetApp () {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          for (let registration of registrations) {
            registration.unregister()
          }
        })
        .then(function (boolean) {
          caches.delete('v1-engineerportal-cache').then(function (boolean) {
            window.location.reload(true)
          })
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Settings.vue?b3d2f854